<!--

import BaseModalCrop from "@/components/base/BaseModalCrop.vue";

-->
<template>
  <b-modal
    v-model="isModalVisible"
    centered
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @shown="initCroppie"
  >
    <div class="crop">
      <vue-croppie
        ref="croppieRef"
        :enable-orientation="false"
        :enable-resize="false"
        :boundary="{ width: 300, height: 200 }"
        :viewport="{ width: 300, height: 200 }"
        class="crop__croppie"
      />

      <div class="crop__actions">
        <b-button pill block variant="secondary" @click="onCropImage">
          Crop
        </b-button>

        <b-button
          pill
          block
          variant="outline-info"
          @click="isModalVisible = false"
        >
          Cancel
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
// utils
import { getRef } from "@/utils/dom";

export default {
  props: {
    value: {
      type: [Object, String],
      required: true,
    },
    modalVisible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    isModalVisible: {
      get() {
        return this.modalVisible;
      },
      set(val) {
        this.$emit("update:modalVisible", val);
      },
    },
    fileModel: {
      get() {
        return this.value;
      },
      async set(val) {
        await this.initCroppie();

        this.$emit("input", val);
      },
    },
  },

  methods: {
    async initCroppie() {
      const croppie = await getRef.call(this, "croppieRef");

      croppie.bind({
        url: this.fileModel,
      });
    },

    async toggleModal() {
      this.isModalVisible = !this.isModalVisible;

      if (!this.isModalVisible) {
        return;
      }
    },

    onCropImage() {
      const options = {
        format: "jpeg",
      };

      this.$refs.croppieRef.result(options, (output) => {
        this.fileModel = output;
        this.isModalVisible = false;
        this.$emit("crop", output);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.crop {
  &__actions {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: space-between;

    ::v-deep button {
      margin: 0;
    }
  }
}
</style>
